import { List, ListItem, VStack } from '@chakra-ui/react';

import Text from 'components/_core/Text';

import { locales } from './locales';
import { APPLICATION_FOLLOW_UP_STEPS } from './statuses';
import { ApplicationStep, ApplicationStepCardBody } from './types';

const ApplicationSignatureBody: ApplicationStepCardBody = () => (
  <>
    <VStack align="stretch" spacing="space-16" width="full">
      <List listStyleType="disc" paddingLeft="space-16" spacing="space-4">
        <ListItem>
          <Text>{locales.applicationSignature.signStatutes}</Text>
        </ListItem>
      </List>
    </VStack>
  </>
);

export const applicationSignatureStep = {
  activeBadgeLabel: locales.activeBadgeLabel.todo,

  body: ApplicationSignatureBody,

  isActive: ({ capitalDeposit }) =>
    APPLICATION_FOLLOW_UP_STEPS[capitalDeposit.status] === 'registration',

  title: locales.applicationSignature.title,
} satisfies ApplicationStep;
